import { Component, OnInit } from '@angular/core';
import {StaffFormDialog} from '@ft/core';

@Component({
  selector: 'common-staff-dialog',
  templateUrl: './common-staff-dialog.component.html',
})
export class CommonStaffDialogComponent extends StaffFormDialog {
}
